var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElectricCarChargersafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 966.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .electricCarChargers_after_svg__cls-2{fill:#a5d1d6}.electricCarChargers_after_svg__cls-4{fill:#343a50}.electricCarChargers_after_svg__cls-5{fill:#bc8264}.electricCarChargers_after_svg__cls-13,.electricCarChargers_after_svg__cls-16,.electricCarChargers_after_svg__cls-7{fill:#dedede}.electricCarChargers_after_svg__cls-12,.electricCarChargers_after_svg__cls-18,.electricCarChargers_after_svg__cls-19,.electricCarChargers_after_svg__cls-21,.electricCarChargers_after_svg__cls-22,.electricCarChargers_after_svg__cls-23,.electricCarChargers_after_svg__cls-24,.electricCarChargers_after_svg__cls-25,.electricCarChargers_after_svg__cls-29,.electricCarChargers_after_svg__cls-32,.electricCarChargers_after_svg__cls-33,.electricCarChargers_after_svg__cls-34,.electricCarChargers_after_svg__cls-38,.electricCarChargers_after_svg__cls-39,.electricCarChargers_after_svg__cls-43,.electricCarChargers_after_svg__cls-45,.electricCarChargers_after_svg__cls-48,.electricCarChargers_after_svg__cls-49,.electricCarChargers_after_svg__cls-51,.electricCarChargers_after_svg__cls-55,.electricCarChargers_after_svg__cls-56,.electricCarChargers_after_svg__cls-58,.electricCarChargers_after_svg__cls-63,.electricCarChargers_after_svg__cls-64,.electricCarChargers_after_svg__cls-7,.electricCarChargers_after_svg__cls-70,.electricCarChargers_after_svg__cls-8{stroke:#343a50}.electricCarChargers_after_svg__cls-48,.electricCarChargers_after_svg__cls-49,.electricCarChargers_after_svg__cls-51,.electricCarChargers_after_svg__cls-7,.electricCarChargers_after_svg__cls-70{stroke-linecap:round}.electricCarChargers_after_svg__cls-48,.electricCarChargers_after_svg__cls-49,.electricCarChargers_after_svg__cls-7{stroke-linejoin:round}.electricCarChargers_after_svg__cls-12,.electricCarChargers_after_svg__cls-18,.electricCarChargers_after_svg__cls-49,.electricCarChargers_after_svg__cls-51,.electricCarChargers_after_svg__cls-7,.electricCarChargers_after_svg__cls-8{stroke-width:2px}.electricCarChargers_after_svg__cls-8{fill:#7fc3ca}.electricCarChargers_after_svg__cls-12,.electricCarChargers_after_svg__cls-18,.electricCarChargers_after_svg__cls-19,.electricCarChargers_after_svg__cls-21,.electricCarChargers_after_svg__cls-22,.electricCarChargers_after_svg__cls-23,.electricCarChargers_after_svg__cls-24,.electricCarChargers_after_svg__cls-25,.electricCarChargers_after_svg__cls-29,.electricCarChargers_after_svg__cls-32,.electricCarChargers_after_svg__cls-33,.electricCarChargers_after_svg__cls-34,.electricCarChargers_after_svg__cls-38,.electricCarChargers_after_svg__cls-39,.electricCarChargers_after_svg__cls-43,.electricCarChargers_after_svg__cls-45,.electricCarChargers_after_svg__cls-51,.electricCarChargers_after_svg__cls-55,.electricCarChargers_after_svg__cls-56,.electricCarChargers_after_svg__cls-58,.electricCarChargers_after_svg__cls-63,.electricCarChargers_after_svg__cls-64,.electricCarChargers_after_svg__cls-70,.electricCarChargers_after_svg__cls-8{stroke-miterlimit:10}.electricCarChargers_after_svg__cls-9{fill:#eb9a6b}.electricCarChargers_after_svg__cls-12{fill:#89bb21}.electricCarChargers_after_svg__cls-13,.electricCarChargers_after_svg__cls-15{mix-blend-mode:multiply}.electricCarChargers_after_svg__cls-14{fill:#6b472d}.electricCarChargers_after_svg__cls-18,.electricCarChargers_after_svg__cls-28,.electricCarChargers_after_svg__cls-37,.electricCarChargers_after_svg__cls-50,.electricCarChargers_after_svg__cls-64{fill:#fff}.electricCarChargers_after_svg__cls-19,.electricCarChargers_after_svg__cls-29{fill:#ce2232}.electricCarChargers_after_svg__cls-19{stroke-width:1.92px}.electricCarChargers_after_svg__cls-21{fill:#4254bc}.electricCarChargers_after_svg__cls-21,.electricCarChargers_after_svg__cls-22,.electricCarChargers_after_svg__cls-23{stroke-width:3.36px}.electricCarChargers_after_svg__cls-22,.electricCarChargers_after_svg__cls-45,.electricCarChargers_after_svg__cls-48{fill:#ffccb5}.electricCarChargers_after_svg__cls-23{fill:#ba9079}.electricCarChargers_after_svg__cls-24,.electricCarChargers_after_svg__cls-38{fill:#201a1a}.electricCarChargers_after_svg__cls-24{stroke-width:2.49px}.electricCarChargers_after_svg__cls-25{fill:#a81628}.electricCarChargers_after_svg__cls-25,.electricCarChargers_after_svg__cls-29{stroke-width:2.59px}.electricCarChargers_after_svg__cls-49,.electricCarChargers_after_svg__cls-51,.electricCarChargers_after_svg__cls-70{fill:none}.electricCarChargers_after_svg__cls-55{fill:#525254}.electricCarChargers_after_svg__cls-28{opacity:.17}.electricCarChargers_after_svg__cls-32,.electricCarChargers_after_svg__cls-33{fill:#d32918;stroke-width:1.73px}.electricCarChargers_after_svg__cls-33{fill:#f59c4a}.electricCarChargers_after_svg__cls-34{fill:#666363;stroke-width:2.06px}.electricCarChargers_after_svg__cls-43{fill:#3f3b3a}.electricCarChargers_after_svg__cls-37{opacity:.32}.electricCarChargers_after_svg__cls-38{stroke-width:3.64px}.electricCarChargers_after_svg__cls-39{fill:#e5e5e5}.electricCarChargers_after_svg__cls-39,.electricCarChargers_after_svg__cls-45,.electricCarChargers_after_svg__cls-48,.electricCarChargers_after_svg__cls-55,.electricCarChargers_after_svg__cls-56,.electricCarChargers_after_svg__cls-58,.electricCarChargers_after_svg__cls-63,.electricCarChargers_after_svg__cls-64{stroke-width:3px}.electricCarChargers_after_svg__cls-43{stroke-width:2.8px}.electricCarChargers_after_svg__cls-56{fill:#aaa}.electricCarChargers_after_svg__cls-58{fill:#fcfcfc}.electricCarChargers_after_svg__cls-63{fill:#fff300}.electricCarChargers_after_svg__cls-70{stroke-width:1.42px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__E-Tankstellen_Nachher"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "electricCarChargers_after_svg__Himmel",
    width: 1258,
    height: 632.62,
    y: -113.36,
    className: "electricCarChargers_after_svg__cls-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Wiese"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 272.75,
    x: -1,
    y: 517.85,
    fill: "#a9bf5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 518.85V789.6H0V518.85h1258m2-2H-2V791.6h1262V516.85z",
    className: "electricCarChargers_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Haus_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368.96,
    height: 263.65,
    x: 891.05,
    y: 253.39,
    className: "electricCarChargers_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259 254.39v261.66H892V254.39h367m2-2H890v265.66h371V252.39z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.47,
    height: 191.35,
    x: 939.52,
    y: 325.4,
    fill: "#9e6b54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104 326.4v189.35H940.52V326.4H1104m2-2H938.52v193.35H1106V324.4z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132.83,
    height: 179.85,
    x: 954.74,
    y: 336.9,
    className: "electricCarChargers_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.57 337.9v177.85H955.74V337.9h130.83m2-2H953.74v181.85h134.83V335.9z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940.52,
    x2: 955.74,
    y1: 326.4,
    y2: 337.9,
    className: "electricCarChargers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1103.99,
    x2: 1086.57,
    y1: 326.4,
    y2: 337.9,
    className: "electricCarChargers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 82.02,
    height: 167.27,
    x: 981.25,
    y: 349.11,
    className: "electricCarChargers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1020.1 516.27 1020.1 473.14 981.25 473.14 981.25 468.72 1020.1 468.72 1020.1 429.04 981.25 429.04 981.25 424.62 1020.1 424.62 1020.1 385.35 981.25 385.35 981.25 380.93 1020.1 380.93 1020.1 349.38 1024.52 349.38 1024.52 380.93 1063.05 380.93 1063.05 385.35 1024.52 385.35 1024.52 424.62 1063.05 424.62 1063.05 429.04 1024.52 429.04 1024.52 468.72 1063.21 468.72 1063.21 473.14 1024.52 473.14 1024.52 516.27 1020.1 516.27",
    className: "electricCarChargers_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.52 350.38v31.55h38.53v2.42h-38.53v41.27h38.53V428h-38.53v41.68h38.69v2.42h-38.69v43.13h-2.43v-43.09h-38.83v-2.42h38.83V428h-38.83v-2.42h38.83v-41.23h-38.83v-2.42h38.83v-31.55h2.43m2-2h-6.43v31.55h-38.83v6.42h38.83v37.27h-38.83V430h38.83v37.68h-38.83v6.42h38.83v43.13h6.43v-43.09h38.69v-6.42h-38.69V430h38.53v-6.42h-38.53v-37.23h38.53v-6.42h-38.53v-31.55z",
    className: "electricCarChargers_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Haus_rechts-2",
    "data-name": "Haus_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445.18,
    height: 219.65,
    x: -1,
    y: 297.1,
    className: "electricCarChargers_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18 298.1v217.65H0V298.1h443.18m2-2H-2v221.65h447.18V296.1z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.47,
    height: 191.35,
    x: 48.58,
    y: 325.4,
    fill: "#bc7353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 326.4v189.35H49.58V326.4H213m2-2H47.58v193.35H215V324.4z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132.83,
    height: 179.85,
    x: 63.79,
    y: 336.9,
    fill: "#d38259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62 337.9v177.85H64.79V337.9h130.83m2-2H62.79v181.85h134.83V335.9z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.58,
    x2: 64.79,
    y1: 326.4,
    y2: 337.9,
    className: "electricCarChargers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.04,
    x2: 195.62,
    y1: 326.4,
    y2: 337.9,
    className: "electricCarChargers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.32 517.27 90.3 516.79 90.3 349.11 172.32 349.11 172.32 517.27",
    className: "electricCarChargers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.1 517.24 129.1 472.73 90.29 472.73 90.29 468.31 129.1 468.31 129.1 349.38 133.52 349.38 133.52 468.31 172 468.31 172 472.73 133.52 472.73 133.52 517.24 129.1 517.24",
    className: "electricCarChargers_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52 350.38v118.93H171v2.42h-38.48v44.51h-2.42v-44.51H91.29v-2.42h38.81V350.38h2.42m2-2h-6.42v118.93H89.28v6.42h38.8v44.51h6.42v-44.51H173v-6.42h-38.48V348.38z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.56,
    height: 163.3,
    x: 336.41,
    y: 325.3,
    className: "electricCarChargers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.27 488.32 381.27 411.79 336.39 411.79 336.39 401.89 381.27 401.89 381.27 325.3 391.13 325.3 391.13 401.89 435.94 401.89 435.94 411.79 391.13 411.79 391.13 488.32 381.27 488.32",
    className: "electricCarChargers_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12 326.3v76.59h44.82v7.9h-44.82v76.53h-7.84v-76.53H337.4v-7.9h44.88V326.3h7.84m2-2h-11.85v76.59h-44.88v11.9h44.88v76.54h11.86v-76.54h44.81v-11.9h-44.81V324.3z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.56,
    height: 163.3,
    x: 228.17,
    y: 325.33,
    className: "electricCarChargers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.16 488.35 273.16 411.92 228.4 411.92 228.4 402.03 273.16 402.03 273.16 325.55 282.99 325.55 282.99 402.03 327.69 402.03 327.69 411.92 282.99 411.92 282.99 488.35 273.16 488.35",
    className: "electricCarChargers_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 326.55V403h44.7v7.89H282v76.43h-7.83v-76.4H229.4V403h44.76v-76.45H282m2-2h-11.84V401H227.4v11.89h44.76v76.43H284v-76.4h44.7V401H284v-76.45z",
    className: "electricCarChargers_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Baum5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.19,
    cy: 396.15,
    className: "electricCarChargers_after_svg__cls-12",
    rx: 90.61,
    ry: 91.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15 397.9c0-50.44 40.57-91.33 90.61-91.33 2.07 0 4.13.08 6.17.22a90.4 90.4 0 00-18.74-2c-50 0-90.6 40.88-90.6 91.32 0 48.35 37.27 87.91 84.44 91.11a91.19 91.19 0 01-71.88-89.32z",
    className: "electricCarChargers_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.11 663.64a4.57 4.57 0 01-3.31-1.41 4.43 4.43 0 01-1.23-3.29L151 446.63l-16.33-16.53a1.49 1.49 0 01-.33-1.67 1.51 1.51 0 011.41-1 1.48 1.48 0 01.68.16l15.39 7.5 2.18-31.51.13-2.52a4.37 4.37 0 018.71-.16l1.44 19.72 15.28-8.15h.15a2.92 2.92 0 01.5-.05 2.69 2.69 0 011.59 4.82l-16.1 11.72 14.48 229.84a4.41 4.41 0 01-1.15 3.36 4.58 4.58 0 01-3.38 1.48z",
    className: "electricCarChargers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46 397.9a3.25 3.25 0 013.34 3.1l1.55 21.23 16.5-8.8a1.73 1.73 0 01.32 0 1.69 1.69 0 011 3l-16.53 12 14.56 230.42a3.5 3.5 0 01-3.53 3.77h-34.56a3.51 3.51 0 01-3.54-3.65l14.49-212.74-16.68-16.83a.54.54 0 01.37-.93.53.53 0 01.24.06l16.72 8.15 2.25-33 .13-2.54a3.27 3.27 0 013.37-3.21m0-2a5.26 5.26 0 00-5.37 5.11l-.13 2.54-2 30-14-6.85a2.54 2.54 0 00-2.91 4.08L150 447l-14.42 211.86a5.39 5.39 0 001.49 4 5.61 5.61 0 004 1.73h34.54a5.57 5.57 0 004.11-1.8 5.44 5.44 0 001.41-4.15l-14.44-229.22L182.33 418a3.69 3.69 0 00-2.16-6.65 3.79 3.79 0 00-.67.06l-.31.06-.28.15-13.79 7.38-1.32-18.17a5.29 5.29 0 00-5.34-4.94z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_after_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.48 424l18.13-9.67a1.61 1.61 0 00-1.76-.88l-16.5 8.8zM156 438.29l2.35-34.64.13-2.54a3.24 3.24 0 011.65-2.78 3.37 3.37 0 00-5.07 2.78l-.13 2.54-2.24 33zM141 659l14.48-212.74-15.73-15.9-3.75-1.83a.54.54 0 00-.61.87l16.68 16.85L137.57 659a3.51 3.51 0 003.54 3.65h3.42A3.5 3.5 0 01141 659z",
    className: "electricCarChargers_after_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Wiese-2",
    "data-name": "Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-1 967.64 -1 756.12 463.81 516.27 794.2 518.68 1259 756.12 1259 967.64 -1 967.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.05 517.27l329.95 2.4 464 237.06v209.91H0V756.73l464.05-239.46m-.48-2l-.44.23L-.92 755l-1.08.56v213.08h1262V755.5l-1.09-.55-464-237.06-.43-.21H794l-329.91-2.4z",
    className: "electricCarChargers_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "644.59 966.64 620.42 966.64 622.28 882.84 641.32 882.84 644.59 966.64",
    className: "electricCarChargers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.32 814.18 622.28 814.18 625.95 730.38 639.82 730.38 641.32 814.18",
    className: "electricCarChargers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.56 576.82 627.04 576.82 629.44 534.91 635.06 534.91 636.56 576.82",
    className: "electricCarChargers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.56 599.53 627.04 599.53 625.95 669.16 639.82 669.16 636.56 599.53",
    className: "electricCarChargers_after_svg__cls-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__E-Tankstellen_Vorher"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "747.9 442.55 777.77 459.2 786 454.28 801.75 450.94 909.26 450.94 917.94 459.2 945.52 442.55 934.03 432.4 914.37 431.12 769.86 431.12 755.44 436.73 747.9 442.55",
    className: "electricCarChargers_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.93 452.6l55-.85h1.2l54.2.85c15.92.25 30.79 41.7 32.29 46q.14.38.3.75l7.6 17.45h10.26l-8.61-18.9q-.18-.39-.33-.78c-1.68-4.48-18.26-47.51-35.63-48.6l-59.83-.89h-1.32l-60.73.89C768 449 752.11 491.79 750.24 497c-.13.35-.27.71-.43 1.05l-8.67 18.77h10l7.5-17c.24-.54.46-1.09.65-1.65 2.09-6.09 16.16-45.43 32.64-45.57z",
    className: "electricCarChargers_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.92,
    points: "848.17 520.61 847.06 520.61 751.15 516.82 750.95 517.26 847.06 520.61 847.09 521.72 942.75 517.26 942.55 516.82 848.17 520.61",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.21 594.09l5.72-65.42a7.76 7.76 0 00-7.76-7.76h-41.09a7.76 7.76 0 00-7.76 7.76l6.92 66 34.63-.47c3.61-.07 9.49 1.7 9.34-.11z",
    className: "electricCarChargers_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.81 513.08c-.27 1-1.73 6.85 3 10.44a11 11 0 002.41 1.36l1.2-.45c1-.5 4.46-2.42 5.42-5.9a6.78 6.78 0 000-3.63",
    className: "electricCarChargers_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "753.53 524.88 752.02 529.28 742.46 583.68 753.53 588.17 761.96 540.79",
    className: "electricCarChargers_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.6 524.35l2.18 4.11 17.89 52.25-1.84 1.11-8.4 5.06q-7.83-22.75-15.68-45.51",
    className: "electricCarChargers_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.7 498.94c-3.76-.76-6.52-3.35-6.52-6.43s2.63-5.55 6.26-6.37M805.52 499c3.76-.76 6.52-3.35 6.52-6.43s-2.63-5.54-6.26-6.37",
    className: "electricCarChargers_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.05 474.94c0-.07-.07-.07 0 0zM809.33 472.55c-.48-1.94-3.42-12.2-3.81-11.59a18.27 18.27 0 00-4.41-5.25c-4.29-3.24-8.51-4-12.14-4.7-1.58-.29-20.47.36-20.58 1.05s-2.19 2-2.9 2.48a20.86 20.86 0 00-6.66 7.44 28.48 28.48 0 00-2.74 7.83c-.24 1-.67 2.76-1 5.14a4.45 4.45 0 01.26 4.1c-1 3.06-1.24 5-.66 4.71.1.91 4.47 15.72 4.52 16.49v.56a14.91 14.91 0 00.2 3.61A16.55 16.55 0 00763 512a22.3 22.3 0 009.7 6.9 22.77 22.77 0 0015 .56 32.48 32.48 0 006.5-3.46 49.1 49.1 0 007.78-6c1.64-1.44 2.47-2.28 2.81-3.61a20 20 0 00.16-3.93v-2.16l.57-1.32c0-3.15 3.83-17.08 3.84-19.23.04-4.1.47-5.19-.03-7.2z",
    className: "electricCarChargers_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.32,
    height: 53.77,
    x: 700.85,
    y: 665.06,
    className: "electricCarChargers_after_svg__cls-24",
    rx: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.32,
    height: 53.77,
    x: 949.97,
    y: 665.06,
    className: "electricCarChargers_after_svg__cls-24",
    rx: 12.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.41 533.31a76.21 76.21 0 000-10.93h11.29l-4.16-11.28c-16.55.44-28.7.8-32.78.83a12.71 12.71 0 00-4.16.71c-1.27.45-4 1.4-5.34 3.8s-.54 5.31.24 7.84a17.54 17.54 0 004.39 7.48c4.3 4.25 9.82 4.82 16 5.47a51.25 51.25 0 0012.47-.24 1.51 1.51 0 00.39-.15c1.15-.57 1.49-2.09 1.66-3.53z",
    className: "electricCarChargers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.84 530.73a48.77 48.77 0 000-7.52H724l-3-7.76c-12 .31-20.78.55-23.74.58a9.41 9.41 0 00-3 .49 6.76 6.76 0 00-3.87 2.61c-1 1.73-.39 3.65.17 5.39a12.06 12.06 0 003.19 5.15c3.11 2.92 7.11 3.31 11.61 3.76a39.41 39.41 0 009-.17 2 2 0 00.28-.1c.83-.39 1.08-1.44 1.2-2.43z",
    className: "electricCarChargers_after_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 535.69a76.07 76.07 0 010-10.92h-11.3l4.16-11.28c16.55.44 28.69.79 32.78.83a12.63 12.63 0 014.15.71c1.27.44 4 1.4 5.35 3.8s.54 5.31-.24 7.84a17.54 17.54 0 01-4.4 7.48c-4.3 4.25-9.82 4.82-16 5.46a51.67 51.67 0 01-12.47-.23 2.65 2.65 0 01-.39-.15c-1.14-.57-1.49-2.1-1.64-3.54z",
    className: "electricCarChargers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.59 532.88a48.61 48.61 0 010-7.51h-8.17l3-7.76c12 .3 20.78.55 23.74.57a9.69 9.69 0 013 .49 6.76 6.76 0 013.87 2.61c1 1.73.39 3.65-.17 5.39a12.06 12.06 0 01-3.19 5.15c-3.11 2.92-7.11 3.31-11.61 3.76a39.41 39.41 0 01-9-.17.87.87 0 01-.28-.1c-.78-.39-1.07-1.44-1.19-2.43z",
    className: "electricCarChargers_after_svg__cls-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 847.76,
    x2: 847.74,
    y1: 448.26,
    y2: 464.27,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.09,
    height: 11.73,
    x: 825.7,
    y: 458.41,
    fill: "#525254",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.36,
    rx: 4.32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "974.41 499.68 960.45 468.07 935 435.4 923.98 428.17 763.81 429.7 756.45 433.51 736.02 454.44 718.9 499.68 715.02 510.78 791.92 516.28 896.62 516.28 980.49 510.08 974.41 499.68",
    className: "electricCarChargers_after_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.7 434.13l74.42-1.13h1.62l73.31 1.14c21.52.34 41.64 56.4 43.67 62.24.12.34.26.68.4 1L976.4 521h13.87l-11.63-25.56c-.16-.35-.31-.7-.45-1.06-2.27-6.06-24.69-64.25-48.19-65.72l-80.91-1.21h-1.79l-82.13 1.21c-24.82.66-46.33 58.49-48.86 65.53-.17.48-.37 1-.58 1.43L704 521h13.54l10.15-23c.33-.74.62-1.49.88-2.24 2.81-8.23 21.84-61.44 44.13-61.63z",
    className: "electricCarChargers_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.59,
    points: "848.76 526.11 847.25 526.11 717.54 520.99 717.27 521.59 847.25 526.11 847.3 527.61 976.67 521.59 976.4 520.99 848.76 526.11",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.57 575.31c1.78 1.06 4.39 2.59 7.57 4.38 3 1.68 15.81 8.87 23.47 11.91 11.88 4.71 22.53 3.87 30.12 3.5 27.65-1.34 55.31 2.74 83 3.5 76.82 2.12 78.89 6.24 90.35-.7 12.66-7.66 35.83-28.25 46.93-26.27a17.31 17.31 0 018.76 4.21c1.94 2 2.71 4 4.2 8a62.75 62.75 0 012.8 10.86c.93 4.84 1.31 8.57 1.4 9.45.42 4.19.52 8 0 21.37 0 0-.62 16-2.1 28.71a58.85 58.85 0 01-1.05 6.31 62.77 62.77 0 01-2.57 8.4c-3.78 9.27-16.28 19.3-30.58 21.72-1.11.18-2 .29-2.57.35-131.19.48-174.14.3-187 0-13.74-.32-22.25-1.44-39.4-.53-6.45.35-8.13.66-11.55 0-19.45-3.72-29.2-26-30-27.84-3.06-7.28-3.36-15.37-4.2-31.52-.91-17.36 1.35-18.74.53-29.94a31.21 31.21 0 011-11.56 32.51 32.51 0 012.62-6.3c1.34-2.56 4.86-7.8 6.45-9.06z",
    className: "electricCarChargers_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 508.41h245.45a23.06 23.06 0 0123.06 23.06v43.14a34.88 34.88 0 01-34.88 34.88H736.86A34.88 34.88 0 01702 574.61v-43.14a23.06 23.06 0 0123-23.06z",
    className: "electricCarChargers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcdbd6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.59,
    d: "M711.54 512.78a23 23 0 00-9.54 18.69v37.35h15.84a9.61 9.61 0 009.61-9.61v-22.92a25.35 25.35 0 00-15.91-23.51z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 558.95,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 526.68,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 542.76,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.54 512.78a23 23 0 00-9.54 18.69v37.35h15.84a9.61 9.61 0 009.61-9.61v-22.92a25.35 25.35 0 00-15.91-23.51z",
    className: "electricCarChargers_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.3,
    height: 21.8,
    x: 791.15,
    y: 542.76,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    rx: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3b3a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.06,
    d: "M946.78 648.75h-190a8.26 8.26 0 00-8.23 8.23v33.21c10.66-.09 18.13.62 28.69.87 12.57.29 53.8.47 177.73 0V657a8.26 8.26 0 00-8.19-8.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 558.95,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 526.68,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.04,
    cy: 542.76,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.74 512.78a23 23 0 019.56 18.69v37.35h-15.84a9.6 9.6 0 01-9.6-9.61v-22.92a25.34 25.34 0 0115.88-23.51z",
    className: "electricCarChargers_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980.24,
    cy: 558.95,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980.24,
    cy: 526.68,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980.24,
    cy: 542.76,
    r: 7.11,
    className: "electricCarChargers_after_svg__cls-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.7-40.17c6.08-14.29 21.47-24.5 39.64-24.5 17.94 0 33.22 10 39.45 24a32.55 32.55 0 018-1.11c16.4 0 29.68 11.85 29.68 26.46s-13.28 26.47-29.68 26.47h-77.13C171.26 11.12 158-.73 158-15.35c0-11.48 8.23-21.16 19.7-24.82zM664.62 40.21C674.83 16.2 700.68-.95 731.2-.95c30.14 0 55.8 16.71 66.26 40.27A54.76 54.76 0 01811 37.46c27.54 0 49.85 19.9 49.85 44.44s-22.36 44.45-49.85 44.45H681.35c-27.54 0-49.85-19.9-49.85-44.45 0-19.29 13.86-35.54 33.12-41.69zM503.81-15.51C497.19-31 480.46-42.16 460.7-42.16c-19.52 0-36.13 10.82-42.9 26.07a35.79 35.79 0 00-8.74-1.2c-17.82 0-32.27 12.88-32.27 28.77s14.45 28.78 32.27 28.78H493c17.83 0 32.28-12.89 32.28-28.78-.03-12.48-9.01-23.01-21.47-26.99zM923 8.25c5.74-13.49 20.27-23.13 37.41-23.13 16.94 0 31.36 9.39 37.24 22.63a31 31 0 017.59-1c15.47 0 28 11.18 28 25s-12.54 25-28 25h-72.83c-15.47 0-28-11.18-28-25-.01-10.91 7.78-20.04 18.59-23.5z",
    className: "electricCarChargers_after_svg__cls-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Baum3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.15,
    cy: 365.99,
    className: "electricCarChargers_after_svg__cls-12",
    rx: 87.01,
    ry: 87.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.21 367.66c0-48.43 39-87.7 87-87.7q3 0 5.93.21a86.83 86.83 0 00-18-1.89c-48.05 0-87 39.27-87 87.71 0 46.43 35.8 84.42 81.09 87.49a87.56 87.56 0 01-69.02-85.82z",
    className: "electricCarChargers_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.55 622.91a4.46 4.46 0 01-3.21-1.37 4.29 4.29 0 01-1.19-3.18L1088 414.48l-15.71-15.86a1.53 1.53 0 011.07-2.6 1.57 1.57 0 01.67.16l14.72 7.18 2.06-30.24.13-2.42a4.23 4.23 0 018.44-.16l1.37 18.88 14.63-7.8h.16a2.61 2.61 0 012 4.65l-15.45 11.25 13.95 220.73a4.3 4.3 0 01-1.12 3.26 4.43 4.43 0 01-3.27 1.43z",
    className: "electricCarChargers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.21 367.66a3.12 3.12 0 013.21 3l1.49 20.39 15.84-8.45a1.67 1.67 0 01.31 0 1.61 1.61 0 01.94 2.9l-15.87 11.5 14 221.29a3.36 3.36 0 01-3.39 3.62h-33.17a3.38 3.38 0 01-3.4-3.5l13.92-204.31-16-16.18a.52.52 0 01.6-.84l16 7.83 2.16-31.72.13-2.44a3.13 3.13 0 013.23-3.09m0-2a5.13 5.13 0 00-5.23 5l-.13 2.43-1.95 28.73-13.39-6.53a2.52 2.52 0 00-2.89 4l15.38 15.57-13.85 203.41a5.28 5.28 0 001.45 4 5.47 5.47 0 003.94 1.68h33.17a5.45 5.45 0 004-1.75 5.38 5.38 0 001.38-4L1103.2 398l15-10.9a3.62 3.62 0 00-2.12-6.52 4.89 4.89 0 00-.66.05l-.31.06-.28.15-13.13 7-1.26-17.32a5.17 5.17 0 00-5.21-4.83z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_after_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 392.71l17.42-9.29a1.55 1.55 0 00-1.7-.85l-15.81 8.43zM1092.87 406.46l2.26-33.27.13-2.44a3.08 3.08 0 011.59-2.67 3.23 3.23 0 00-4.87 2.67l-.13 2.44-2.15 31.72zM1078.43 618.41l13.91-204.31-15.11-15.27-3.59-1.75a.52.52 0 00-.6.84l16 16.18-13.92 204.31a3.38 3.38 0 003.4 3.5h3.28a3.38 3.38 0 01-3.37-3.5z",
    className: "electricCarChargers_after_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Baum2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1166.47,
    cy: 494.09,
    className: "electricCarChargers_after_svg__cls-12",
    rx: 61.55,
    ry: 62.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.46 495.28c0-34.27 27.56-62 61.55-62 1.41 0 2.81.05 4.19.14a61.36 61.36 0 00-12.73-1.33c-34 0-61.55 27.78-61.55 62 0 32.85 25.32 59.73 57.36 61.9a62 62 0 01-48.82-60.71z",
    className: "electricCarChargers_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.27 676.14a3.43 3.43 0 01-2.49-1.07 3.31 3.31 0 01-.92-2.46l9.82-144.1-11-11.13a1.37 1.37 0 011-2.33 1.42 1.42 0 01.6.14l10 4.89 1.43-21 .08-1.71a3.29 3.29 0 016.56-.12l.94 12.91 10-5.33h.55a2.15 2.15 0 011.28 3.85l-10.81 7.86 9.86 156a3.34 3.34 0 01-.87 2.52 3.45 3.45 0 01-2.53 1.11z",
    className: "electricCarChargers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.05 495.28a2.2 2.2 0 012.27 2.1l1.06 14.42 11.2-6a.86.86 0 01.22 0 1.14 1.14 0 01.67 2.05l-11.23 8.15 9.89 156.54a2.39 2.39 0 01-2.4 2.57h-23.46a2.39 2.39 0 01-2.41-2.48l9.84-144.53-11.33-11.45a.37.37 0 01.25-.63.35.35 0 01.17 0l11.36 5.54 1.52-22.44.09-1.73a2.22 2.22 0 012.29-2.18m0-2a4.19 4.19 0 00-4.28 4.08l-.09 1.72-1.33 19.45-8.68-4.24a2.37 2.37 0 00-2.72 3.8l10.7 10.8-9.78 143.63a4.32 4.32 0 001.19 3.24 4.43 4.43 0 003.21 1.38h23.46a4.47 4.47 0 003.27-1.44 4.31 4.31 0 001.12-3.3L1176.3 517l10.34-7.53a3.14 3.14 0 00-1.88-5.64 2.75 2.75 0 00-.57.05l-.31.05-.28.15-8.49 4.53-.83-11.36a4.23 4.23 0 00-4.27-4z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_after_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1173.46 513l12.32-6.57a1.1 1.1 0 00-1.2-.59l-11.2 6zM1168.4 522.72l1.59-23.53.09-1.73a2.19 2.19 0 011.13-1.89 2.3 2.3 0 00-3.45 1.89l-.08 1.73-1.53 22.44zM1158.18 672.66l9.82-144.53-10.69-10.8-2.54-1.24a.37.37 0 00-.42.59l11.33 11.45-9.84 144.53a2.39 2.39 0 002.41 2.48h2.32a2.38 2.38 0 01-2.39-2.48z",
    className: "electricCarChargers_after_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Baum1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1241.33,
    cy: 355.69,
    className: "electricCarChargers_after_svg__cls-12",
    rx: 122.4,
    ry: 123.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.9 358.05c0-68.14 54.81-123.37 122.41-123.37 2.8 0 5.57.1 8.33.29a122.1 122.1 0 00-25.31-2.65c-67.6 0-122.41 55.24-122.41 123.37 0 65.31 50.36 118.76 114.08 123.08-55.46-11.77-97.1-61.33-97.1-120.72z",
    className: "electricCarChargers_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 716.7a5.85 5.85 0 01-4.23-1.81 5.58 5.58 0 01-1.55-4.17l19.54-287-22.22-22.44a1.73 1.73 0 012-2.78l21.25 10.36 2.94-43.14.17-3.41a5.55 5.55 0 0111.07-.2l2 27.16 21.03-11.2h.15a3.27 3.27 0 012.54 5.82l-21.9 15.95 19.64 310.72a5.65 5.65 0 01-1.47 4.28 5.84 5.84 0 01-4.3 1.89z",
    className: "electricCarChargers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.44 358.05a4.39 4.39 0 014.52 4.17l2.09 28.69 22.29-11.91a3.28 3.28 0 01.43 0 2.28 2.28 0 011.33 4.09l-22.33 16.25 19.67 311.28a4.73 4.73 0 01-4.77 5.1H1225a4.73 4.73 0 01-4.78-4.93l19.57-287.4-22.54-22.77a.73.73 0 01.51-1.25.66.66 0 01.32.08l22.59 11 3-44.62.17-3.43a4.41 4.41 0 014.55-4.34m0-2a6.41 6.41 0 00-6.54 6.24l-.18 3.43-2.84 41.62-19.83-9.72a2.67 2.67 0 00-1.2-.28 2.74 2.74 0 00-1.93 4.66l21.9 22.12-19.51 286.5a6.63 6.63 0 001.83 5 6.88 6.88 0 005 2.12h46.66a6.86 6.86 0 005-2.21 6.71 6.71 0 001.72-5.07l-19.6-310.13 21.44-15.6a4.28 4.28 0 00-2.5-7.71 5.14 5.14 0 00-.78.07l-.31.06-.28.15-19.58 10.44-1.86-25.67a6.39 6.39 0 00-6.52-6z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_after_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.22 393.28l24.5-13.07a2.18 2.18 0 00-2.38-1.19l-22.29 11.89zM1245.15 412.62l3.18-46.8.18-3.43a4.36 4.36 0 012.23-3.76 4.56 4.56 0 00-6.85 3.76l-.17 3.43-3 44.62zM1224.84 710.77l19.57-287.4-21.26-21.48-5.06-2.46a.73.73 0 00-.83 1.17l22.54 22.77-19.57 287.4a4.73 4.73 0 004.78 4.92h4.61a4.73 4.73 0 01-4.78-4.92z",
    className: "electricCarChargers_after_svg__cls-16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Auto_links"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.54,
    height: 78.4,
    x: 90.73,
    y: 834.82,
    className: "electricCarChargers_after_svg__cls-38",
    rx: 17.85
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.54,
    height: 78.4,
    x: 463.37,
    y: 834.82,
    className: "electricCarChargers_after_svg__cls-38",
    rx: 17.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.16 642.83 125.45 642.83 134.52 577.76 486.16 577.76 486.16 642.83",
    className: "electricCarChargers_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 233.61,
    height: 57.25,
    x: 199.34,
    y: 575.03,
    fill: "#b7b6b6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.22 502.35 429.11 483.11 412.45 472.82 203.75 475.03 165.28 504.73 226.56 524.6 405.26 525.66 450.22 502.35",
    className: "electricCarChargers_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.13,
    d: "M236.72 528.81l71.28-1.39v0h1.55v0l70.19 1.39c20.61.42 39.87 68.9 41.82 76 .11.42.24.83.38 1.25l9.84 28.82H445l-11.1-31.18c-.15-.43-.29-.87-.42-1.31-2.18-7.39-23.65-78.48-46.15-80.27l-77.47-1.48v0h-1.71v0l-78.64 1.48c-23.76.81-44.36 71.44-46.78 80-.16.59-.35 1.17-.56 1.75l-11.23 31h13l9.72-28c.31-.91.59-1.82.84-2.74 2.67-10.08 20.88-75.08 42.22-75.32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5e5e5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.13,
    points: "309.86 634.91 308.15 634.91 183.91 634.91 183.66 635.65 307.98 635.65 309.53 635.65 432.01 635.65 431.76 634.91 309.86 634.91",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6 570.95h52a28.36 28.36 0 0128.4 28.36v37.14H331.24v-37.14a28.36 28.36 0 0128.36-28.36z",
    className: "electricCarChargers_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.68,
    height: 41.27,
    x: 346.31,
    y: 525.27,
    className: "electricCarChargers_after_svg__cls-43",
    rx: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51 570.27h52a28.36 28.36 0 0128.36 28.36v37.14H176.14v-37.14a28.36 28.36 0 0128.37-28.36z",
    className: "electricCarChargers_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.68,
    height: 41.27,
    x: 191.21,
    y: 524.6,
    className: "electricCarChargers_after_svg__cls-43",
    rx: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M409.58 671.66l7.11-81.33a9.65 9.65 0 00-9.65-9.65H356a9.65 9.65 0 00-9.65 9.65l8.61 82.08 43-.59c4.5-.11 11.81 2.09 11.62-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51 571c-.33 1.62-2.15 11.3 3.74 17.22a13.46 13.46 0 003 2.25l1.5-.75a16.21 16.21 0 006.74-9.74 15.05 15.05 0 000-6",
    className: "electricCarChargers_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.25,
    x2: 381.13,
    y1: 590.42,
    y2: 672.78,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M412.45 506.14c-2.28-3.65-3.92-5.34-5.48-6.52-5.34-4-10.58-5-15.09-5.84-2-.36-25.46.44-25.6 1.3s-2.71 2.49-3.6 3.08a26 26 0 00-8.28 9.25c-1.77 3.18-2.42 5.78-3.4 9.73-.31 1.22-.84 3.44-1.29 6.4-.46-.51 1.6 1.31.31 5.08s-1.54 6.19-.81 5.86c.12 1.13.27 2.14.33 3.1l5.84.49 4.86-14.07 7.79-8.4 9.25 2.56 9.25 6.32 11.66 4.18L411.94 539l5.25-1.46v-8.05c0-5.12.58-6.48 0-9s-4.26-15.11-4.74-14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24 553.36c-4.67-.94-8.11-4.16-8.11-8s3.28-6.9 7.78-7.92M412.45 553.44c4.67-.94 8.11-4.16 8.11-8s-3.28-6.9-7.78-7.92",
    className: "electricCarChargers_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93 507.41a28.82 28.82 0 00-8.28 4.38c-8.7 7.27-9.61 18.57-9.73 21.9v2.43c0 6.39-.09 13.69.48 19a26.57 26.57 0 00.49 2.92 27.06 27.06 0 001.46 4.38c2.09 4.66 6.89 8.44 7.3 8.76a29.54 29.54 0 0011.68 5.35c3.52.84 9.5 2.35 16.06 0a38.71 38.71 0 006.57-3.65 50.61 50.61 0 0011.2-9.25c1.67-1.89 2.7-3.41 2.92-5.35.07-.62 0-1 0-3.41V551c0-2.65.17-11.06.49-22.39a28.1 28.1 0 00-7.31-2.92C401 524.6 393.15 520 382.88 514c-3.23-1.89-5.8-3.45-8.76-5.36-2.35-1.5-4.32-2.84-5.85-3.89",
    className: "electricCarChargers_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.16 527.85a7 7 0 013.9-2.43 7.17 7.17 0 015.84 1.46M393.6 528.62a6.92 6.92 0 013.89-2.43 7.24 7.24 0 015.84 1.46M375.82 561.92a14.75 14.75 0 004.87 2 14.52 14.52 0 005.84 0 13.8 13.8 0 005.35-2.44M379.23 551.7a4.38 4.38 0 008.27 0",
    className: "electricCarChargers_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.03,
    cy: 538.8,
    className: "electricCarChargers_after_svg__cls-50",
    rx: 4.87,
    ry: 3.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.69,
    cy: 538.8,
    className: "electricCarChargers_after_svg__cls-50",
    rx: 4.87,
    ry: 3.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.79,
    cy: 539.04,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 1.7,
    ry: 2.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.45,
    cy: 538.56,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 1.7,
    ry: 2.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 543.91a6 6 0 011.46-.49 5.69 5.69 0 011.95 0M415.24 548.29a2.28 2.28 0 001-1.46c.19-1.37-1.29-2.32-1.46-2.43a3.61 3.61 0 00-2.44-.49",
    className: "electricCarChargers_after_svg__cls-51"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "347.82 585.62 345.94 591.08 334.05 658.71 347.82 664.31 358.29 605.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.36,
    d: "M415 585l2.7 5.1L440 655l-2.29 1.38-10.44 6.28-19.49-56.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M375.06 570.27a14 14 0 00-1.5 1L354.82 555c0 .23 0 .46-.05.7a19.3 19.3 0 00.25 4.48 20.55 20.55 0 004.59 9.47 27.59 27.59 0 0012.06 8.57c3.09 1.17 10.62 3.41 18.64.7 2.35-.79 4.25-2 8.07-4.28a61.87 61.87 0 009.67-7.48c2-1.79 3.07-2.84 3.49-4.48.13-.51.18-1 .2-4.89v-3.09l-19.24 16.03a18.26 18.26 0 00-1.69-.85c-.44-.19-8.61-3.61-15.75.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.33,
    height: 33.43,
    x: 369.54,
    y: 605.31,
    className: "electricCarChargers_after_svg__cls-55",
    transform: "rotate(-29.97 372.793 622.099)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.43,
    height: 6.33,
    x: 383.71,
    y: 618.86,
    className: "electricCarChargers_after_svg__cls-55",
    transform: "rotate(-60.02 400.446 622.032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5 690.68a47.85 47.85 0 1147.85-47.85 47.9 47.9 0 01-47.85 47.85zm0-86.2a38.36 38.36 0 1038.35 38.35 38.4 38.4 0 00-38.35-38.35z",
    className: "electricCarChargers_after_svg__cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29 582.09c.64 5.44.07 14.62 0 15.66h16.17l-6 16.17c-23.72-.63-41.12-1.14-47-1.19a18.3 18.3 0 01-6-1c-1.82-.64-5.74-2-7.65-5.45s-.78-7.6.34-11.23a25.34 25.34 0 016.29-10.73c6.17-6.08 14.08-6.9 23-7.82a73.43 73.43 0 0117.87.34 2.1 2.1 0 01.56.21c1.68.79 2.13 2.95 2.42 5.04zM507.39 582c-.65 5.44-.07 14.62 0 15.66h-16.17l5.95 16.17c23.72-.64 41.13-1.15 47-1.19a18.56 18.56 0 006-1c1.82-.64 5.74-2 7.66-5.45 2-3.61.78-7.61-.34-11.24a25.26 25.26 0 00-6.3-10.72c-6.16-6.08-14.08-6.91-23-7.83a73.94 73.94 0 00-17.87.34 3.41 3.41 0 00-.55.21c-1.64.81-2.14 3.05-2.38 5.05z",
    className: "electricCarChargers_after_svg__cls-56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.93,
    x2: 307.91,
    y1: 476.8,
    y2: 504.01,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74.89,
    height: 19.93,
    x: 270.46,
    y: 494.04,
    className: "electricCarChargers_after_svg__cls-55",
    rx: 7.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85 613a8.09 8.09 0 014.36-2.61 7.39 7.39 0 017.19 2.58c2.27 3.05.61 7.11-.26 9.26a13.16 13.16 0 01-5.93 6.87c-2.28 1.21-7.17 2.86-9.6.71-3.42-3.06-.31-12.2 4.24-16.81zM427 610.31a8.61 8.61 0 00-5.17 1.57 6.17 6.17 0 00-2.72 5.18c.1 2.31 1.75 2.42 2.45 5.4.6 2.58-.45 3.3.54 5 1.21 2 3.87 2.78 4.36 2.92 3.73 1.07 8.64-.1 10.62-2.92 1.68-2.4.54-5-.82-8.11-.91-2.06-3.84-8.73-9.26-9.04z",
    className: "electricCarChargers_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "494.46 632.09 300.07 635.65 117.15 630.49 180.99 473.6 429.34 476.69 494.46 632.09",
    className: "electricCarChargers_after_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.83 478.92l102.28-2H310.34l100.76 2c29.58.61 57.22 98.9 60 109.13.17.61.35 1.2.55 1.79l14.13 41.39h19.06l-16-44.81c-.22-.62-.43-1.24-.61-1.87-3.12-10.62-33.94-112.66-66.24-115.24l-111.2-2.11v-.05h-2.46v.05l-112.88 2.11c-34.11 1.16-63.67 102.56-67.15 114.9-.24.85-.5 1.69-.8 2.51l-16.12 44.51H130L144 591q.67-2 1.2-3.93c3.85-14.51 30-107.81 60.63-108.15z",
    className: "electricCarChargers_after_svg__cls-58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcfcfc",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "310.37 640.21 308.3 640.21 130.02 631.23 129.66 632.28 308.3 640.21 308.36 642.83 486.16 632.28 485.8 631.23 310.37 640.21",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6 705.39c2.6 1.54 6.4 3.77 11.05 6.38 4.37 2.45 23 12.93 34.21 17.36 17.32 6.87 32.86 5.64 43.91 5.11 40.33-2 80.66 4 121 5.1 112 3.09 115 9.1 131.74-1C460 727.15 493.78 697.14 510 700a25.3 25.3 0 0112.76 6.12c2.83 2.88 4 5.9 6.13 11.75a90.51 90.51 0 014.08 15.83c1.36 7.06 1.92 12.5 2 13.79.61 6.1.76 11.73 0 31.14 0 0-.91 23.28-3.07 41.88a85.78 85.78 0 01-1.53 9.19 92 92 0 01-3.72 12.3c-5.51 13.52-23.75 28.14-44.6 31.66-1.61.28-2.94.43-3.74.51-191.29.71-253.91.44-272.69 0-20-.46-32.44-2.09-57.44-.76-9.4.5-11.86 1-16.85 0-28.36-5.43-42.57-38-43.66-40.6-4.46-10.62-4.9-22.4-6.13-46-1.32-25.32 2-27.32.77-43.66a45.69 45.69 0 011.53-16.85 48.31 48.31 0 013.83-9.19c2-3.72 7.08-11.36 9.4-13.2z",
    className: "electricCarChargers_after_svg__cls-58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3b3a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M85.15 825.06a49.94 49.94 0 002.52 7.73c1.09 2.61 15.3 35.17 43.66 40.6 5 1 7.45.5 16.85 0 25-1.33 37.4.3 57.44.76 18.78.44 81.4.71 272.69 0 .8-.08 2.13-.23 3.74-.51 20.85-3.52 39.09-18.14 44.6-31.66a92 92 0 003.74-12.25c.2-.87.36-1.68.51-2.47v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eae9e8",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M496.43 625.86l7.28-1.41 2.94 6.13c3.41 9.26 5.78 17.21 7.4 23.23 2.2 8.17 3.35 12.52 4.09 18.9 1 9-.38 8.07.76 18a67.15 67.15 0 01-.13 13.4 13.63 13.63 0 01-1.53 5.11 12.63 12.63 0 01-1.66 2.38A76.87 76.87 0 01502 724.2c-13.94 9.27-26.9 16-26.9 16-12.57 6.52-18.85 9.78-26 12.59-6.32 2.48-5.89 2-31.15 9.36a74.21 74.21 0 01-14.3 2.9c-3.09.3-5.45.33-6.47.34-36.53.33-90.21 0-90.21 0-22 .49-44-.39-66 0-10.84.19-20.6.46-34-1.7a179.06 179.06 0 01-38.13-10.9c-4.79-1.89-12.27-5.57-27.24-12.93a264.3 264.3 0 01-25.87-14.64s-3.83-2.34-12.59-10.56c-2.57-2.4-4.35-4.25-5.45-7.14-1.41-3.73-.61-7.07-.68-8.52a154 154 0 017.49-56.51 144.94 144.94 0 017.49-18c.88.24 2.24.61 3.91 1 0 0 9.72 2.43 20.09 3.92 23.35 3.35 55.32 4.08 55.32 4.08 48.17 1.11 15.11.75 55.57 1.45 40.1.69 60.15 1 76.34 1 28.59 0 17.31-.52 76.09-1.28 21.7-.28 47.09-.52 65.36-3.32 15.03-2.34 31.76-5.48 31.76-5.48z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.99,
    cy: 707.22,
    r: 7.39,
    fill: "#c2c2c2",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.35,
    cy: 660.99,
    r: 11.94,
    className: "electricCarChargers_after_svg__cls-63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.92,
    cy: 660.99,
    r: 11.94,
    className: "electricCarChargers_after_svg__cls-63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.48,
    cy: 680.59,
    r: 10.79,
    className: "electricCarChargers_after_svg__cls-64"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.28,
    cy: 680.59,
    r: 10.79,
    className: "electricCarChargers_after_svg__cls-64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231e1a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M199.34 728.79h218v0a28.09 28.09 0 01-28.09 28.09H227.42a28.09 28.09 0 01-28.09-28.09v0h.01z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.98,
    cy: 319.47,
    className: "electricCarChargers_after_svg__cls-50",
    rx: 121.77,
    ry: 83.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.23,
    cy: 405.77,
    className: "electricCarChargers_after_svg__cls-50",
    rx: 18.66,
    ry: 15.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.67,
    cy: 432.43,
    className: "electricCarChargers_after_svg__cls-50",
    rx: 15.62,
    ry: 9.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.12,
    cy: 455.95,
    r: 4.85,
    className: "electricCarChargers_after_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.58,
    d: "M150 353.77h109.36a10.37 10.37 0 0010.34-10.34v-6.81h5.51a10.37 10.37 0 0010.33-10.34v-13A10.37 10.37 0 00275.21 303h-5.51v-6.81a10.37 10.37 0 00-10.34-10.34H150a10.36 10.36 0 00-10.33 10.34v47.28a10.36 10.36 0 0010.33 10.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.88,
    height: 52.35,
    x: 152.58,
    y: 293.64,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.88,
    height: 52.35,
    x: 206.44,
    y: 293.05,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.88,
    height: 52.35,
    x: 233.33,
    y: 293.54,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.88,
    height: 52.35,
    x: 180.22,
    y: 293.05,
    className: "electricCarChargers_after_svg__cls-4",
    rx: 6.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.58,
    height: 148.49,
    x: 1194.22,
    y: 563.4,
    fill: "#343a50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108.76,
    height: 122.78,
    x: 1143.13,
    y: 438.18,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.86,
    rx: 20.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.1 456h-30.2a2.52 2.52 0 00-2.53 2.52v59a2.52 2.52 0 002.53 2.52h30.2a2.52 2.52 0 002.52-2.52v-59a2.52 2.52 0 00-2.52-2.52zm-3.39 22.07a2.33 2.33 0 01-2.34 2.33h-18.75a2.33 2.33 0 01-2.33-2.33v-14.28a2.33 2.33 0 012.33-2.34h18.75a2.34 2.34 0 012.34 2.34z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.36,
    d: "M1169.51 461.33a26.45 26.45 0 00-3.3 9.26 23 23 0 00.32 9.81c1.1 4.11 2.39 3.79 3.86 8.21.8 2.4 2.33 7 1 11.91-.51 1.84-1.23 3-2.09 6.6-.55 2.28-.83 3.44-.65 4.67a8 8 0 005 6.36c3.35 1.15 7.25-.39 8.53-2.82.18-.33.42-.91.48-4.1a52.63 52.63 0 00-.16-6c-1.57-14.62 1.21-32.76.73-37.1a1.66 1.66 0 012.25-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.43 459.29v.57a4.14 4.14 0 004.13 4.13h.56a4.14 4.14 0 004.13-4.13v-.28l-7.72-3.07a4.07 4.07 0 00-1.1 2.78z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1171.84,
    x2: 1168.86,
    y1: 452,
    y2: 457.55,
    className: "electricCarChargers_after_svg__cls-70"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1176.09,
    x2: 1173.11,
    y1: 454.27,
    y2: 459.83,
    className: "electricCarChargers_after_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.45 461.33h2.13v14H1182v-9.53a4.47 4.47 0 014.45-4.47z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343a50",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 32.36,
    transform: "matrix(1.04 0 0 1 1155.15 551.57)"
  }, "\r\n      100m\r\n     ")), /*#__PURE__*/React.createElement("g", {
    id: "electricCarChargers_after_svg__Baum4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.42,
    cy: 353.53,
    className: "electricCarChargers_after_svg__cls-12",
    rx: 114.48,
    ry: 115.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.18 355.73c0-63.72 51.25-115.39 114.48-115.39 2.62 0 5.22.1 7.79.28a114 114 0 00-23.67-2.48c-63.23 0-114.49 51.66-114.49 115.39 0 61.09 47.11 111.08 106.7 115.12-51.87-11-90.81-57.37-90.81-112.92z",
    className: "electricCarChargers_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 691.25a5.56 5.56 0 01-4-1.71 5.25 5.25 0 01-1.47-3.95L28 417.21l-20.76-21a1.64 1.64 0 01-.36-1.83 1.65 1.65 0 012.29-.87l19.79 9.65 2.74-40.26.16-3.18a5.25 5.25 0 0110.48-.2l1.84 25.31 19.63-10.47h.16a2.81 2.81 0 01.57-.05 3 3 0 012.91 2.13 3.08 3.08 0 01-1.06 3.48l-20.5 14.9 18.37 290.6a5.36 5.36 0 01-1.39 4.05 5.54 5.54 0 01-4.07 1.78z",
    className: "electricCarChargers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.07 355.73a4.12 4.12 0 014.23 3.91l2 26.83 20.8-11.12h.4a2.13 2.13 0 011.24 3.82l-20.88 15.2 18.4 291.14a4.43 4.43 0 01-4.46 4.77H15.15a4.44 4.44 0 01-4.47-4.61L29 416.83 7.91 395.54a.69.69 0 01.47-1.18.62.62 0 01.31.08l21.12 10.3L32.65 363l.17-3.2a4.13 4.13 0 014.25-4.07m0-2a6.13 6.13 0 00-6.25 6l-.16 3.2L28 401.64l-18.46-9a2.68 2.68 0 00-3.07 4.3l20.44 20.65L8.69 685.5a6.33 6.33 0 001.74 4.73 6.55 6.55 0 004.72 2H58.8a6.5 6.5 0 004.8-2.11 6.3 6.3 0 001.65-4.84l-18.32-290 20-14.56a4.12 4.12 0 00-2.42-7.43 4.74 4.74 0 00-.75.06l-.31.06-.28.15-18.17 9.7-1.7-23.76a6.1 6.1 0 00-6.23-5.77z",
    className: "electricCarChargers_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "electricCarChargers_after_svg__cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.42 388.68l22.91-12.22a2.06 2.06 0 00-2.23-1.11l-20.84 11.12zM34 406.78L37 363l.16-3.2a4.08 4.08 0 012.1-3.52 4.26 4.26 0 00-6.41 3.52l-.17 3.2-2.83 41.74zM15 685.64l18.3-268.81-19.88-20.09-4.73-2.3a.68.68 0 00-.78 1.1L29 416.83 10.68 685.64a4.44 4.44 0 004.47 4.61h4.32a4.43 4.43 0 01-4.47-4.61z",
    className: "electricCarChargers_after_svg__cls-16"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCarChargersafter);
export default __webpack_public_path__ + "static/media/electricCarChargers.after.353d51cc.svg";
export { ForwardRef as ReactComponent };